import React from 'react';
import { Zap, Loader2 } from 'lucide-react';
import { Box, Typography, Pressable } from '@/shared/design-system/primitives';

interface CoachAdviceCardProps {
    coachAdvice: string | null;
    isCoachAnalyzing: boolean;
    onRefresh: () => void;
}

/**
 * CoachAdviceCard: Tactical AI analysis display.
 * V5.3: Edge-to-edge layout with 20px internal padding.
 */
export const CoachAdviceCard: React.FC<CoachAdviceCardProps> = ({ coachAdvice, isCoachAnalyzing, onRefresh }) => {
    const cardStyle = {
        padding: 20,
        borderBottomWidth: 1,
        marginBottom: 15,
        backgroundColor: 'rgba(6, 182, 212, 0.02)',
        borderColor: 'rgba(6, 182, 212, 0.2)'
    } as any;

    return (
        <Box style={cardStyle}>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10, marginBottom: 15 }}>
                <Zap size={16} color="#06b6d4" />
                <Typography style={{ fontSize: 11, fontWeight: '900', color: '#fff', letterSpacing: 1 }}>AI COACH ADVISORY</Typography>
            </Box>
            
            {!coachAdvice && !isCoachAnalyzing && (
                <Pressable onPress={onRefresh} style={{ backgroundColor: 'rgba(6, 182, 212, 0.1)', paddingVertical: 12, borderRadius: 8, borderWidth: 1, borderColor: '#06b6d4', alignItems: 'center' }}>
                    <Typography style={{ color: '#06b6d4', fontSize: 10, fontWeight: '900', letterSpacing: 1 }}>REQUEST METABOLIC ANALYSIS</Typography>
                </Pressable>
            )}

            {isCoachAnalyzing && (
                <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8, paddingVertical: 8 }}>
                    <Loader2 size={14} color="#06b6d4" className="animate-spin" />
                    <Typography style={{ fontSize: 11, color: '#888', fontWeight: 'bold' }}>Synthesizing 4-Pillar diagnostics...</Typography>
                </Box>
            )}

            {coachAdvice && !isCoachAnalyzing && (
                <Box style={{ display: 'flex', flexDirection: 'column', flexShrink: 1 }}>
                    <Typography style={{ fontSize: 12, color: '#eee', lineHeight: 18, flexWrap: 'wrap', width: '100%' } as any}>{coachAdvice}</Typography>
                    <Pressable onPress={onRefresh} style={{ marginTop: 15, alignSelf: 'flex-start' }}>
                        <Typography style={{ color: '#06b6d4', fontSize: 9, fontWeight: 'bold', opacity: 0.8 }}>↻ REFRESH ANALYSIS</Typography>
                    </Pressable>
                </Box>
            )}
        </Box>
    );
};
